import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Team } from '../../models/team.model';
import { AuthService } from '../../../auth/auth.service';
import { Platform, ToastController } from '@ionic/angular';
import { NavController } from '@ionic/angular';
import { END_POINT } from '../../../../environments/environment';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { ToastService } from '../../../_core/services/toast.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: false
})
export class ToolbarComponent {
  @Input() team: Team;
  @Input() isCollapsed = false;
  @Input() canFollow = false;
  @Input() isOwner: boolean = false;
  @Input() isOfficial = false;
  @Input() isAuthenticationRequired = false;
  @Input() segmentValue!: string;
  @Input() innerSegmentValue!: string;
  @Output() innerSegmentChange = new EventEmitter<string>();
  @Output() followChange = new EventEmitter<void>();
  @Output() joinTeam = new EventEmitter<void>();
  @Output() segmentChange = new EventEmitter<string>();
  @Output() showTeamPopover = new EventEmitter<string>();
  @Input() authService: AuthService;
  @Input() segmentButtons: { value: string, label: string, visible: boolean }[] = [];
  @Input() innerSegmentButtons: { label: string; value: string; visible: boolean }[] = [];
  @Input() ITAlogo: string;
  @Input() isUserTeamPlayer: boolean = false;
  @Input() collapseProgress = 0;
  @Input() isParticipantLoading = false;

  isIos = false;
  isWeb = false;

  constructor(
    private navCtrl: NavController,
    private platform: Platform,
    private toastService: ToastService
  ) {
    if (this.platform.is('ios')) {
      // Covers iOS app + iOS Safari/Chrome
      this.isIos = true;
      this.isWeb = false;
    } else if (this.platform.is('android') || this.platform.is('desktop') || this.platform.is('mobileweb')) {
      // Android app/browser + Desktop
      this.isIos = false;
      this.isWeb = true;
    }
  }


  onSegmentChange(event: any) {
    this.segmentValue = event.detail.value;
    this.segmentChange.emit(this.segmentValue);
  }

  onInnerSegmentChange(event: any) {
    this.innerSegmentValue = event.detail.value;
    this.innerSegmentChange.emit(this.innerSegmentValue);
  }

  onShowTeamPopover(action: string) {
    this.showTeamPopover.emit(action);
  }

  onFollowClick() {
    this.followChange.emit();
  }

  onJoinTeamClick() {
    this.joinTeam.emit();
  }

  getTeamColor(team: Team, location: string) {
    return team?.colors?.length > 0 ? team.colors[0] : location === 'home' ? '#3f51b5' : '#009688';
  }

  goBack() {
    this.navCtrl.navigateRoot('/my-teams');
    // navigates back in Ionic�s navigation stack
  }


  async shareTeamLink() {
    let baseUrl: string;

    if (Capacitor.isNativePlatform()) {
      baseUrl = END_POINT + '/';
    } else {
      baseUrl = window.location.origin + '/';
    }

    const joinUrl = `${baseUrl}join/${this.team._id}`;
    const staffUrl = `${baseUrl}my-teams/${this.team._id}`;

    // Decide which link to share
    const linkToShare = staffUrl;
    // const linkToCopy = this.isOwner ? joinUrl : staffUrl;

    if (Capacitor.isNativePlatform()) {
      // Use Capacitor Clipboard API for native
      await Share.share({
        title: 'Team Link',
        text: 'Join or view the team using this link:',
        url: linkToShare,
        dialogTitle: 'Share Team Link'
      });
    } else {
      // Use browser clipboard for web
      await navigator.clipboard.writeText(linkToShare);
    }

    this.toastService.presentToast('Link is copied to the clipboard');
  }



  getTeamAbbreviation(team: any): string {
    let abbr = team?.abbreviation ?? team.name;
    // Ensure exactly 3 characters
    if (abbr.length > 3) {
      return abbr.slice(0, 3).toUpperCase(); // truncate
    } else if (abbr.length < 3) {
      return abbr.padEnd(3, ''); // optional: pad with spaces if needed
    }
    return abbr.toUpperCase();
  }


}


